import { Link, Outlet } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import Navbarmenu from "../function-components/Navbarmenu";
import { useEffect } from "react";
import { fetchCourses } from "../function-components/Redux/BundleSkillsSlice";
import { useSelector,useDispatch } from "react-redux";
import { getloggedInUserRoles } from "../Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";
import LoadingSpinner from "../utils/loadingSpinner";

function Home() {
  const loggedInUser= useSelector((state)=>state.deliveryLeadership.enterpriseID);
  const dispatch= useDispatch();

  useEffect(()=>{
    dispatch(fetchCourses);
  },[]);

  useEffect(() => {
    if (loggedInUser) {
      dispatch(getloggedInUserRoles({loggedInUser, trackId:2}));  //trackId for bundleSkills = 2
    }
  }, [loggedInUser,dispatch]);

  const userRoles= useSelector((state)=>state.deliveryLeadership.loggedInUserRoles);
  
  if (!userRoles) {
  return <LoadingSpinner />;
}

  const navArr=[
    {name:"Recommended Trainings", path:"recommended-trainings"}
  ]
  if(userRoles.includes("th")){
    navArr.push( {name:"TH", path:"TH"});
  }
  return (
    <div>
      <Navbarmenu items={navArr}/>
      <Outlet />
    </div>
  );
}

export default Home;
